(() => {
  function initAnnouncementRotation(root = document) {
    const components = root.querySelectorAll(
      'slideshow-component.announcement-bar'
    );

    components.forEach((component) => {
      if (component.dataset.nrRotationReady === 'true') return;

      const slider = component.querySelector('.slider');
      if (!slider) return;

      const slides = Array.from(
        slider.querySelectorAll('.slideshow__slide')
      );

      if (slides.length < 2) return;

      let currentSlide = 0;
      let timer = null;

      const showSlide = (index) => {
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;

          slide.style.display = isActive ? '' : 'none';
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      };

      const nextSlide = () => {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
      };

      const previousSlide = () => {
        currentSlide =
          (currentSlide - 1 + slides.length) % slides.length;
        showSlide(currentSlide);
      };

      const previousButton = component.querySelector(
        '.slider-button--prev'
      );

      const nextButton = component.querySelector(
        '.slider-button--next'
      );

      previousButton?.addEventListener('click', previousSlide);
      nextButton?.addEventListener('click', nextSlide);

      const autoplay = slider.dataset.autoplay === 'true';
      const speed =
        Math.max(1, Number(slider.dataset.speed) || 5) * 1000;

      const startRotation = () => {
        if (!autoplay || timer) return;
        timer = setInterval(nextSlide, speed);
      };

      const stopRotation = () => {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      };

      component.addEventListener('mouseenter', stopRotation);
      component.addEventListener('mouseleave', startRotation);

      showSlide(currentSlide);
      startRotation();

      component.dataset.nrRotationReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAnnouncementRotation();
    });
  } else {
    initAnnouncementRotation();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAnnouncementRotation(event.target);
  });
})();